import { Routes } from '@angular/router';
import { LoginComponent } from './features/login/login.component';
import { LayoutComponent } from './layout/layout.component';
import { InicioComponent } from './features/inicio/inicio.component';
import { SessionGuard } from './core/guards/sessionGuard';
import { routesPath } from './core/constants/app.constants';

export const routes: Routes = [
  {
    path: '',
    redirectTo: routesPath.login,
    pathMatch: 'full'
  },
  {
    path: routesPath.login,
    component: LoginComponent
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: routesPath.inicio,
        component: InicioComponent,
        canActivate: [SessionGuard]
      },
      {
        path: routesPath.clientes.base,
        loadChildren: () =>
        import('./features/clientes/clientes.routes').then(m => m.routes),
        canActivate: [SessionGuard]
      },
      {
        path: routesPath.contactos.base,
        loadChildren: () =>
        import('./features/contactos/contactos.routes').then(m => m.routes),
        canActivate: [SessionGuard]
      },
      {
        path: routesPath.hosting.base,
        loadChildren: () =>
        import('./features/hosting/hosting.routes').then(m => m.routes),
        canActivate: [SessionGuard]
      },
      {
        path: routesPath.dominios.base,
        loadChildren: () =>
        import('./features/dominios/dominios.routes').then(m => m.routes),
        canActivate: [SessionGuard]
      }
    ]
  },
  {
    path: '**',
    redirectTo: routesPath.login,
    pathMatch: 'full'
  }
];